import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Song } from '../types';
import { usePlayer } from '../contexts/PlayerContext';

const Container = styled.div`
  margin-bottom: 32px;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 16px;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FavoritesList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
`;

const FavoriteItem = styled.div`
  background: var(--card-bg);
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 12px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
  }
`;

const PlayIcon = styled.div`
  width: 40px;
  height: 40px;
  background: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
`;

const SongInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

const SongName = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Rating = styled.div`
  color: var(--primary-color);
  font-size: 0.9rem;
`;

const Favorites: React.FC = () => {
  const [favorites, setFavorites] = useState<Song[]>([]);
  const { playSong } = usePlayer();

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = () => {
    const favs = localStorage.getItem('favorites');
    if (favs) {
      setFavorites(JSON.parse(favs));
    }
  };

  if (favorites.length === 0) return null;

  return (
    <Container>
      <Title>❤️ Suas Favoritas</Title>
      <FavoritesList>
        {favorites.slice(0, 6).map(song => (
          <FavoriteItem key={song.id} onClick={() => playSong(song, favorites)}>
            <PlayIcon>▶️</PlayIcon>
            <SongInfo>
              <SongName>{song.name}</SongName>
              <Rating>⭐ {song.average_rating || 0}/5</Rating>
            </SongInfo>
          </FavoriteItem>
        ))}
      </FavoritesList>
    </Container>
  );
};

export default Favorites;